'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'laptop';
var width = 640;
var height = 512;
var aliases = [128187];
var unicode = 'f109';
var svgPathData = ['M16 403.2c0-1.8 1.4-3.2 3.2-3.2l601.6 0c1.8 0 3.2 1.4 3.2 3.2 0 33.6-27.2 60.8-60.8 60.8L76.8 464C43.2 464 16 436.8 16 403.2zM80 96c0-26.5 21.5-48 48-48l384 0c26.5 0 48 21.5 48 48l0 240-480 0 0-240z', 'M512 48L128 48c-26.5 0-48 21.5-48 48l0 240-16 0 0-240c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 240-16 0 0-240c0-26.5-21.5-48-48-48zM19.2 400c-1.8 0-3.2 1.4-3.2 3.2 0 33.6 27.2 60.8 60.8 60.8l486.4 0c33.6 0 60.8-27.2 60.8-60.8 0-1.8-1.4-3.2-3.2-3.2L19.2 400zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faLaptop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;